import { useState, useEffect } from 'react';
import bookingService from '../../../../../../../services/BookingService';
import getURLParameter from '../../../../../../../../../utils/getURLParams';

import { setLocalStorage } from '../../../../../../../../../utils/setLocalStorage';

export const useUserProfile = ({ onFormSubmit, initialScan }) => {
  const initialAuthToken = initialScan ? null : getURLParameter('auth-token') || localStorage.getItem('token');
  const [authToken, setAuthToken] = useState(initialAuthToken);
  const [userSA, setUserSA] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isAuthTokenValid, setIsAuthTokenValid] = useState(false);

  useEffect(() => {
    const fetchUserProfile = async () => {
      setIsAuthTokenValid(false);
      if (authToken)
        try {
          setIsLoading(true);
          const result = await bookingService.getUserProfile(authToken);
          const { data } = result;
          if (data === null) {
            setAuthToken(null);
            setError(true);
            setIsAuthTokenValid(false);
            return;
          }
          setLocalStorage('token', authToken);

          const emailIdentity = data.identities.find(identity => identity.type === 'EMAIL');
          const phoneIdentity = data.identities.find(identity => identity.type === 'PHONE');
          const email = emailIdentity ? emailIdentity.identity : null;
          const phone = phoneIdentity ? phoneIdentity.identity : null;
          setUserSA({
            firstName: data.firstName,
            lastName: data.lastName,
            email: email,
            phoneNumber: phone?.replace('+', ''),
            isMigrated: data.isMigrated,
          });

          setIsAuthTokenValid(true);

          if (onFormSubmit) {
            if (data.isMigrated) return;
            await onFormSubmit({
              firstName: data.firstName,
              lastName: data.lastName,
              email: email,
              phoneNumber: phone?.replace('+', ''),
              isMigrated: data.isMigrated,
            });
          }
        } catch (error) {
          console.log('userProfile error: ', error);
          setError(true);
          setAuthToken(null);
        } finally {
          setIsLoading(false);
        }
      else setIsLoading(false);
    };
    fetchUserProfile();
  }, [authToken]);

  return { authToken, setAuthToken, userSA, isLoading, setIsLoading, error, isAuthTokenValid };
};
